import { Dispatch, SetStateAction, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useScroll } from "../../provider/ScrollProvider";

export const useStepper = (
  steps: { title: string; description: string }[],
  trigger: () => Promise<boolean>,
  handleSubmit: (onSubmit: (data: FieldValues) => Promise<void>) => () => void,
  onSubmit: (data: FieldValues) => Promise<void>,
  setHasInteracted?: Dispatch<SetStateAction<boolean>>,
) => {
  const [currentStep, setCurrentStep] = useState(0);
  const { scrollToTop } = useScroll();

  const handleNext = async () => {
    setHasInteracted && setHasInteracted(true);
    if (currentStep < steps.length - 1) {
      const isValid = await trigger();
      if (!isValid) {
        return;
      }
      scrollToTop();
      setCurrentStep((prevStep) => prevStep + 1);
    }
  };

  const handleBack = () => {
    setCurrentStep((prevStep) => prevStep - 1);
  };

  const handleFinalSubmit = async () => {
    const isValid = await trigger();
    if (!isValid) return;
    handleSubmit(onSubmit)();
  };

  return {
    currentStep,
    handleNext,
    handleBack,
    handleFinalSubmit,
  };
};
